import { useAuthorization } from 'src/hooks/use-authorization';

export const useShowInlineForms = () => {
  const { getFeatureFlag } = useAuthorization();

  return getFeatureFlag('ux-redesign-v2.5') && getFeatureFlag('inline-forms-redesign');
};
